import { AlertTriangle, Loader2 } from 'lucide-react';

/**
 * Live "X concepts match" chip in the stepper bar. Stays consistent
 * across steps so the user always knows the impact of their current
 * filters. Turns rose when zero matches so the warning is visible
 * before the user clicks Start.
 */
export function MatchCountChip({
  count,
  isLoading,
}: {
  count: number | null;
  isLoading: boolean;
}) {
  if (isLoading || count == null) {
    return (
      <span className='inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 py-1 text-xs text-muted-foreground dark:bg-white/[0.04]'>
        <Loader2 className='h-3 w-3 animate-spin' />
        Counting…
      </span>
    );
  }
  const zero = count === 0;
  const tone = zero
    ? 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-900/60 dark:bg-rose-900/20 dark:text-rose-300'
    : 'border-border bg-card text-foreground dark:bg-white/[0.04]';
  const label = zero
    ? 'No matches'
    : `${count} concept${count === 1 ? '' : 's'} match`;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium tabular-nums ${tone}`}
    >
      {zero && <AlertTriangle className='h-3 w-3' />}
      {label}
    </span>
  );
}
